import React, { useState, useLayoutEffect, useContext } from 'react';

import * as S from './styles';
import Modal from 'components/Modal';
import { Link } from 'types/InputsRedirectableLinkProps';
import SimpleInput from 'components/SimpleInput';
import SelectInput from 'components/SelectInput';
import { optionsRedirectType } from 'utils/optionsInputs';
import { SelectInputItemProps } from 'types/SelectInputItemProps';
import { verifyIfFormCanSave } from './functions';
import SystemNotifyContext from 'context/SystemNotifyContext';
import { generateUid } from 'utils/functions';

const initialState: Link = {
	idFront: '',
	name: '',
	redirect: { type: '', value: '' }
};

interface FormRedirectableLinkProps {
	linkToEdit: null | Link;
	setLinkToEdit: React.Dispatch<React.SetStateAction<null | Link>>;
	isOpen: boolean;
	functionToGetDataAboutLink: any;
	setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
	optionsDynamicScreen: SelectInputItemProps[];
}

export default function FormRedirectableLink({
	setIsOpen,
	isOpen,
	functionToGetDataAboutLink,
	linkToEdit,
	optionsDynamicScreen,
	setLinkToEdit
}: FormRedirectableLinkProps) {
	initialState.idFront = generateUid();

	const { handleNotify } = useContext(SystemNotifyContext);

	const [link, setLink] = useState<Link>(initialState);

	function findOptionOnListById(value: string, list: SelectInputItemProps[]) {
		const itemsList = list.filter((item) => item.id === value);
		if (itemsList.length > 0) {
			return itemsList[0];
		}

		return '';
	}

	function saveLink() {
		const canSave = verifyIfFormCanSave(link, handleNotify);

		if (canSave) {
			functionToGetDataAboutLink(link);
			setIsOpen(false);
			setLink(initialState);
			setLinkToEdit(null);
		}
	}

	function cancel() {
		setIsOpen(false);
		setLink(initialState);
		setLinkToEdit(null);
	}

	useLayoutEffect(() => {
		if (linkToEdit !== null) {
			setTimeout(() => {
				setLink(linkToEdit);
			}, 100);
		}
	}, []);

	return (
		<Modal
			isOpenProps={isOpen}
			setIsOpenModal={() => {
				const newInitialState = structuredClone(initialState);

				setIsOpen((value) => !value);
				setLink(newInitialState);
				setLinkToEdit(null);
			}}
			title={link === null ? 'Adicionar Link' : 'Editar Link'}
			buttonClose={false}
		>
			<S.container>
				<SimpleInput
					label="Nome"
					initialValue={link.name}
					getValue={(value: string) => {
						setLink((obj) => ({ ...obj, name: value }));
					}}
				/>

				<SelectInput
					list={optionsRedirectType}
					getValue={(value: SelectInputItemProps | '') => {
						setLink((obj) => ({
							...obj,
							redirect: {
								...obj.redirect,
								type: value === '' ? value : (value?.id as string)
							}
						}));
					}}
					initialValue={
						link.redirect.type === ''
							? optionsRedirectType[0]
							: findOptionOnListById(
									link.redirect.type || '',
									optionsRedirectType
								)
					}
					label="Tipo de redirecionamento *"
				/>

				{(link.redirect.type === '' ||
					link.redirect.type === 'product' ||
					link.redirect.type === 'url' ||
					link.redirect.type === 'webview' ||
					link.redirect.type === 'query' ||
					link.redirect.type === 'screen_app') && (
					<SimpleInput
						label="Valor do redirecionamento *"
						initialValue={link.redirect.value}
						getValue={(value: string) => {
							setLink((obj) => ({
								...obj,
								redirect: { ...obj.redirect, value: value }
							}));
						}}
					/>
				)}

				{link.redirect.type === 'app_screen' && (
					<SelectInput
						list={optionsDynamicScreen}
						getValue={(value: SelectInputItemProps | '') => {
							setLink((obj) => ({
								...obj,
								redirect: {
									...obj.redirect,
									value: value === '' ? value : (value?.id as string)
								}
							}));
						}}
						initialValue={
							link.redirect.value === ''
								? ''
								: findOptionOnListById(
										link.redirect.value || '',
										optionsDynamicScreen
									)
						}
						label="Valor redirecionamento *"
					/>
				)}

				<S.containerBtns>
					<S.cancel onClick={cancel}>Cancelar</S.cancel>
					<S.save onClick={saveLink}>Salvar</S.save>
				</S.containerBtns>
			</S.container>
		</Modal>
	);
}
